import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { adminInstance } from '../../config/axios';
import { toast } from 'react-toastify';

function GenerateAffiliateModal(props) {
  const [formData, setFormData] = useState({
    // referrerCommission: '',
    // refereeBonus: '',
    referralCode: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    let newErrors = {};
    // if (!formData.referrerCommission) newErrors.referrerCommission = 'Required';
    // if (!formData.refereeBonus) newErrors.refereeBonus = 'Required';
    if (!formData.referralCode) newErrors.referralCode = 'Required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const response = await adminInstance().post(
        'api/admin/generateAdminPromoLink',
        formData
      );
      const { code, msg } = response.data;
      if (code === 200) {
        props.setModalShow(false);
        props.getAdminAllPromoList();
        setFormData({
          referralCode: '',
        });
        toast.success(msg);
      } else {
        toast.error(msg);
      }
    }
  };

  return (
    <Modal
      {...props}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className='text-black text-dark'
        >
          GENERATE AFFILIATE
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} className='needs-validation user-add'>
          <div className='admin-input col-xl-12 col-md-7'>
            {/* <FormGroup>
              <Label className='col-form-label pt-0'>REFERER COMMISSION</Label>
              <Input
                type='number'
                min='0'
                placeholder='REFERER-COMMISSION'
                name='referrerCommission'
                value={formData.referrerCommission}
                onChange={handleChange}
              />
              {errors.referrerCommission && (
                <p className='text-danger'>{errors.referrerCommission}</p>
              )}
            </FormGroup>

            <FormGroup>
              <Label className='col-form-label pt-0'>REFEREE BONUS</Label>
              <Input
                type='number'
                min='0'
                placeholder='REFEREE-BONUS'
                name='refereeBonus'
                value={formData.refereeBonus}
                onChange={handleChange}
              />
              {errors.refereeBonus && (
                <p className='text-danger'>{errors.refereeBonus}</p>
              )}
            </FormGroup> */}

            <FormGroup>
              <Label className='col-form-label pt-0'>REFERRAL Code</Label>
              <Input
                type='text'
                placeholder='REFERRAL CODE'
                name='referralCode'
                value={formData.referralCode}
                onChange={handleChange}
              />
              {errors.referralCode && (
                <p className='text-danger'>{errors.referralCode}</p>
              )}
            </FormGroup>
          </div>

          <div className='form-button'>
            <Button
              color='primary'
              style={{ borderRadius: '25px' }}
              type='submit'
              className='main-btn px-3 py-2 text-center'
            >
              Submit
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default GenerateAffiliateModal;
